import { useEffect } from 'react'
import { Bot, Power, PowerOff } from 'lucide-react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import useAgentStore from '@/stores/useAgentStore'
import { formatDistanceToNow } from 'date-fns'
import { AddAgentDialog } from '@/components/agent/AddAgentDialog'
import { AgentDetailsDialog } from '@/components/agent/AgentDetailsDialog'

const AgentsPage = () => {
  const { agents, fetchAgents, isLoading } = useAgentStore()

  useEffect(() => {
    fetchAgents()
  }, [fetchAgents])

  return (
    <div className="container max-w-6xl mx-auto py-8 px-4">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold">Remote Agents</h1>
        <AddAgentDialog />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>All Registered Agents</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Status</TableHead>
                <TableHead>Name</TableHead>
                <TableHead>Organization ID</TableHead>
                <TableHead>Last Seen</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading && agents.length === 0 ? (
                [...Array(3)].map((_, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <Skeleton className="h-6 w-20" />
                    </TableCell>
                    <TableCell>
                      <Skeleton className="h-6 w-32" />
                    </TableCell>
                    <TableCell>
                      <Skeleton className="h-6 w-40" />
                    </TableCell>
                    <TableCell>
                      <Skeleton className="h-6 w-24" />
                    </TableCell>
                    <TableCell>
                      <Skeleton className="h-8 w-20" />
                    </TableCell>
                  </TableRow>
                ))
              ) : agents.length > 0 ? (
                agents.map((agent) => (
                  <TableRow key={agent.id}>
                    <TableCell>
                      <Badge
                        variant={
                          agent.status === 'online' ? 'default' : 'outline'
                        }
                        className={
                          agent.status === 'online'
                            ? 'bg-green-500 hover:bg-green-600 text-white'
                            : ''
                        }
                      >
                        {agent.status === 'online' ? (
                          <Power className="mr-2 h-4 w-4" />
                        ) : (
                          <PowerOff className="mr-2 h-4 w-4" />
                        )}
                        {agent.status}
                      </Badge>
                    </TableCell>
                    <TableCell className="font-medium flex items-center gap-2">
                      <Bot className="h-5 w-5 text-muted-foreground" />
                      {agent.name}
                    </TableCell>
                    <TableCell>{agent.organizationId}</TableCell>
                    <TableCell>
                      {formatDistanceToNow(new Date(agent.lastSeen), {
                        addSuffix: true,
                      })}
                    </TableCell>
                    <TableCell>
                      <AgentDetailsDialog agentId={agent.id} />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className="h-24 text-center">
                    No agents found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  )
}

export default AgentsPage
